/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
				$('#headerParticleground').particleground({
					dotColor: '#65429C',
					lineColor: '#65429C',
					maxSpeedX: 0.2,
					maxSpeedY: 0.2,
					density: 7500
				});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
				  $(function(){
						 if (jQuery.browser.mobile == true){
							 $('#homeActionVideo').addClass('home-action-video__mobile');
						 } else {
							if($('#P1').length > 0) {
								var YTPlayer = $("#P1").YTPlayer();
								YTPlayer.YTPPlay();
								if( YTPlayer.isPlayer ) {
									overlay.on( "click", function() {
										YTPlayer.YTPTogglePlay();
									});
								}
							}
						}
						 var headings = $('.carousel-item__course--heading, .course-preview--heading');
						 $.each(headings, function(key, heading) {
							$clamp(heading, {clamp: 2});
						 });
					});

				// Fix the width of the home courses scroll div
				// $('.home-courses--scroller-wrapper').mousewheel(function(e, delta) {
				// 	this.scrollLeft -= (delta * 2);
				// 	e.preventDefault();
				// });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
				// Add appropriate margin to the home courses
				var firstCoursePreview, homeCourseLeftMargin, coursePreviewWidth;
				var homeCourseContainer = $('.home-courses > .container');
				if(homeCourseContainer.length) {
					var homeCoursesScroller = $('.home-courses--scroller');
					var updateCoursesScrollerLeftMargin = function() {
						// Get first course-preview for a base of measurement
						firstCoursePreview = $('.course-preview').first()
							//Get the left margin of the container, add it to the padding
						homeCourseLeftMargin = parseInt(homeCourseContainer.css('marginLeft')) + parseInt(homeCourseContainer.css('paddingLeft')) - parseInt(firstCoursePreview.css('marginLeft'));
						// set the courses scroller left margin
						homeCoursesScroller.css('marginLeft', homeCourseLeftMargin + 'px');
					}
					var updateCourseSliderWidth = function() {
						// If on mobile
						if(window.innerWidth < 400) {
							// 
							coursePreviewWidth = window.innerWidth - (parseInt(homeCourseContainer.css('paddingLeft')) * 2);
							// Set course width to width of window minus padding
							$('.course-preview').css('width', coursePreviewWidth + 'px');
						} else {
							// Unset any jQuery styled width
							$('.course-preview').css('width', "");
						}
						var container_width = firstCoursePreview.outerWidth(true) * $('.course-preview').length + parseInt(homeCourseContainer.css('paddingRight')) + parseInt(homeCourseContainer.css('marginRight'));
						console.log(container_width);
						$(".home-courses--scroller").css("width", container_width);

					}
					updateCoursesScrollerLeftMargin();
					updateCourseSliderWidth();
					window.onresize = function() {
						updateCoursesScrollerLeftMargin();
						updateCourseSliderWidth();
					};
				}
				$('#carouselBookOnline').on('click', function() {
					var courseURL = $('#headerCourse .active').data('course-url');
					if(courseURL) {
						window.location.href = courseURL;
					}
				});
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
		'courses': {
			finalize: function() {
				jQuery(function($) {
					// Consider adding an ID to your table
					// incase a second table ever enters the picture.
					var items = $(".carousel-item");

					var numItems = items.length;
					var perPage = 4;

					// Only show the first 2 (or first `per_page`) items initially.
					items.slice(perPage).hide();

					// Now setup the pagination using the `.pagination-page` div.
					$("#coursePagination").pagination({
						items: numItems,
						itemsOnPage: perPage,
						cssStyle: "light-theme",

						// This is the actual page changing functionality.
						onPageClick: function(pageNumber) {
							// We need to show and hide `tr`s appropriately.
							var showFrom = perPage * (pageNumber - 1);
							var showTo = showFrom + perPage;

							// We'll first hide everything...
							items.hide()
								// ... and then only show the appropriate rows.
								.slice(showFrom, showTo).show();
						}
					});



					// EDIT: Let's cover URL fragments (i.e. #page-3 in the URL).
					// More thoroughly explained (including the regular expression) in: 
					// https://github.com/bilalakil/bin/tree/master/simplepagination/page-fragment/index.html

					// We'll create a function to check the URL fragment
					// and trigger a change of page accordingly.
					function checkFragment() {
						// If there's no hash, treat it like page 1.
						var hash = window.location.hash || "#page-1";

						// We'll use a regular expression to check the hash string.
						hash = hash.match(/^#page-(\d+)$/);

						if(hash) {
							// The `selectPage` function is described in the documentation.
							// We've captured the page number in a regex group: `(\d+)`.
							$("#coursePagination").pagination("selectPage", parseInt(hash[1]));
						}
					};

					// We'll call this function whenever back/forward is pressed...
					$(window).bind("popstate", checkFragment);

					// ... and we'll also call it when the page has loaded
					// (which is right now).
					checkFragment();


					$('#pageCoursesSelectSort').on('change', function(e) {
						window.location.href = $('#pageCoursesSelectSort').val();
					});
				});


			}
		},
    'contact': {
      init: function() {
				(function($) {
					$('.page-contact-form--embed-container').click(function () {
								$('.page-contact-form--embed-container iframe').css("pointer-events", "auto");
					});

					$( ".page-contact-form--embed-container" ).mouseleave(function() {
							$('.page-contact-form--embed-container iframe').css("pointer-events", "none"); 
					});
				})(jQuery);
      }
		}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
